import React, {PureComponent, ReactNode} from "react"
import {Mutation, MutationFn, MutationResult} from "@irati/utils/apollo"
import {Mutation as MutationComponent} from "@irati/utils/services/apollo"
import {omit} from "lodash"


import {gql} from "@irati/utils/gql"
import {CompanyValue} from "../../types"

export const mutation = gql`
  mutation ArchiveCompanyValue($companyValue: CompanyValueInput!, $tenantId: String!) {
    archiveCompanyValue(companyValue: $companyValue, tenantId: $tenantId) {
      uuid
    }
  }
`

interface ArchiveCompanyValueData {
  companyValue: CompanyValue
}

interface ArchiveCompanyValueProps {
  children: (mutate: MutationFn, apolloState: MutationResult) => ReactNode
  companyValue: CompanyValue
  tenantId: string
}

function parseCompanyValue(companyValue: CompanyValue) {
  return omit(companyValue, ["__typename"])
}

class TypedMutation extends Mutation<ArchiveCompanyValueData> {}

export default class ArchiveCompanyValueMutation extends PureComponent<ArchiveCompanyValueProps> {
  render() {
    const {children, companyValue, tenantId} = this.props

    return (
      <MutationComponent mutation={mutation} MutationComponent={TypedMutation} {...this.props}>
        {(mutate: MutationFn, apolloState: MutationResult) =>
          children(
            (args: any) =>
              mutate({
                variables: {
                  companyValue: parseCompanyValue(companyValue),
                  tenantId
                },
                refetchQueries: ["CompanyValues"],
                awaitRefetchQueries: true,
                ...args
              }),
            apolloState
          )
        }
      </MutationComponent>
    )
  }
}
